'use client';

import type { IChromeConfig } from '@repo/web-chrome/chrome-config/chrome-config';
import { ChromeConfigContext } from '@repo/web-chrome/chrome-config/chrome-config-context';
import type { JSX, ReactNode } from 'react';
import { useMemo } from 'react';

interface IWebChromeProviderProps extends IChromeConfig {
  children: ReactNode;
}

export function WebChromeProvider({
  siteOrigin,
  catalogOrigin,
  isCatalogApp,
  loadLocalizedPalettePages,
  children,
}: IWebChromeProviderProps): JSX.Element {
  const value = useMemo<IChromeConfig>(
    () => ({ siteOrigin, catalogOrigin, isCatalogApp, loadLocalizedPalettePages }),
    [siteOrigin, catalogOrigin, isCatalogApp, loadLocalizedPalettePages],
  );
  return <ChromeConfigContext.Provider value={value}>{children}</ChromeConfigContext.Provider>;
}
